import { createFileRoute } from "@tanstack/react-router";
import Search from "../components/Search";

export const Route = createFileRoute("/")({
  component: Search,
  validateSearch: (search) => ({
    batchMessage: search.batchMessage ? String(search.batchMessage) : undefined,
  }),
});
